import initialState from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  state: initialState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
  strict: process.env.NODE_ENV !== 'production'
};
